import { css } from '@microsoft/fast-element';
export const foundationStepperTabStyles = (context, definition) => css `
  .tree-item {
    cursor: default;
  }

  .tree-item::part(content-region) {
    margin-inline-start: 0;
  }

  .tree-item[selected]::part(positioning-region):hover {
    background: var(--neutral-fill-rest);
  }

  .tree-item::part(positioning-region):hover {
    background: var(--neutral-fill-stealth-rest);
  }

  .stepper-icon {
    margin-right: 5px;
  }

  .completed-icon {
    color: #69cd70;
  }

  .error-icon {
    color: #f14376;
  }

  .step-number {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 5px 0 0;
    width: 24px;
    height: 24px;
    font-size: 12px;
    color: var(--focus-stroke-outer);
    background-color: var(--neutral-fill-input-rest);
    border-radius: 50%;
    border: 1px solid var(--neutral-fill-input-rest);
  }

  .step-number-container {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .angle-icon {
    color: var(--neutral-fill-input-rest);
    margin: 0 15px;
  }

  .step-title {
    font-size: 14px;
    color: var(--focus-stroke-outer);
  }

  :host([completed]) .step-number {
    border-color: #69cd70;
    color: #69cd70;
  }

  :host([completed]) .step-title,
  :host([completed]) .angle-icon {
    color: #69cd70;
  }

  :host([error]) .step-number {
    border-color: #f14376;
    color: #f14376;
  }

  :host([error]) .step-title {
    color: #f14376;
  }
`;
